import { minBy } from 'lodash';
import ReactHtmlParser from 'react-html-parser';

import { Offer } from '../ContentfulTypes';

import formatCurrency from './formatCurrency';

export const getLowestMonthlyPrice = ({
  variants,
  locale,
  fieldName,
  activeField,
}: {
  variants: Array<Offer>;
  locale: string;
  fieldName: string;
  activeField;
}) => {
  const activeVariants = variants?.filter((variant) => variant[activeField]);
  if (!activeVariants || activeVariants.length === 0) {
    return undefined;
  }
  const minimumVariant = minBy(activeVariants, fieldName);
  const monthlyPhonePrice = formatCurrency(
    minimumVariant ? minimumVariant[fieldName] : undefined,
    locale,
  ).replace(' ', ReactHtmlParser('&nbsp;'));
  return monthlyPhonePrice;
};

export const getLowestDualPricingMonthlyPrice = ({
  variants,
  locale,
}) => {
  const activeVariants = variants?.filter((variant) => variant.isPhoneVariantActive);
  if (!activeVariants || activeVariants.length === 0) {
    return undefined;
  }
  const minimumVariant = minBy<Offer>(
    activeVariants,
    getLowestPrice,
  ) as Offer;
  const minimumVariantValue = getLowestPrice(minimumVariant);
  const monthlyPhonePrice = formatCurrency(
    !Number.isNaN(minimumVariantValue) ? minimumVariantValue : undefined,
    locale,
  ).replace(' ', ReactHtmlParser('&nbsp;'));
  return monthlyPhonePrice;
};

const getLowestPrice = (variant: Offer) => {
  const price = parseFloat(String(variant.monthlyPrice));
  const returnPrice = parseFloat(String(variant.monthlyPriceReturn));

  if (Number.isNaN(returnPrice)) {
    return variant.monthlyPrice;
  }
  
  return price < returnPrice ? variant.monthlyPrice : variant.monthlyPriceReturn;
};
